"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            program: null,
            showModal: false,
            showDialog: false,
            showPosterPlus: false,
            showPosterPlusLoading: false
        };
    },
    onMount: async function () {
        await this.getProgram();
    },
    getProgram: async function () {
        try {
            const {error, message, program} = await Request('/program/' + this.input.params.id);
            if (error)
                throw new Error(message);
            this.state.program = program || false;
        } catch (error) {
            console.log('Error Fetching Program', error);
            this.state.program = false;
        }
    },
    onOutlinesUpdate: async function (outlines, fn) {
        try {
            const {error, message, program} = await Request('/program/update/' + this.input.params.id, 'PUT', { outlines });
            if (error)
                throw new Error(message);
            this.state.program = program;
            typeof fn == 'function' && fn();
        } catch (error) {
            console.log('Error Updating Program Outlines: ', error);
        }
    },
    onAttachmentsUpdate: async function (attachments, fn) {
        try {
            const {error, message, program} = await Request('/program/update/' + this.input.params.id, 'PUT', { attachments });
            if (error)
                throw new Error(message);
            this.state.program = program;
            typeof fn == 'function' && fn();
        } catch (error) {
            console.log('Error Updating Program Attachments: ', error);
        }
    },
    updateProgram: async function (type, updates) {
        try {
            const {error, message} = await Request('/program/update/' + this.input.params.id, 'PUT', { [type]: updates });
            if (error)
                throw new Error(message);
            this.state.program[type] = updates;
            this.setStateDirty('program');
            this.state.showModal = false;
        } catch (error) {
            console.log('Error Updating Program: ', error);
        }
    },
    deleteProgram: function () {
        this.onDialog({
            type: 'warning',
            message: 'Are you sure about deleting this program? The process is irreversible.',
            actions: {
                yes: {
                    fn: async function () {
                        try {
                            const {error, message} = await Request('/program/delete/' + this.input.params.id, 'DELETE');
                            if (error)
                                throw new Error(message);
                            history.back();
                        } catch (error) {
                            console.log('Error Deleting Program: ', error);
                        }
                    }.bind(this)
                }
            }
        });
    },
    onDialog: function (params) {
        this.state.showDialog = params;
    },
    onShowModal: function (type, dataset, callback) {
        this.state.showModal = type !== false ? {
            type,
            dataset,
            callback
        } : type;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Programs/create/Content/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    EmptyList_template = require("../../../../components/EmptyList.marko"),
    EmptyList_tag = marko_loadTag(EmptyList_template),
    Image_template = require("../../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Availability_template = require("../../../../components/Availability/index.marko"),
    Availability_tag = marko_loadTag(Availability_template),
    DifficultyLevel_template = require("../../../../components/DifficultyLevel.marko"),
    DifficultyLevel_tag = marko_loadTag(DifficultyLevel_template),
    StarRating_template = require("../../../../../components/StarRating/index.marko"),
    StarRating_tag = marko_loadTag(StarRating_template),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    WSAdapt_template = require("../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Price_template = require("../../../../../components/Price/index.marko"),
    Price_tag = marko_loadTag(Price_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Schedules_template = require("../../../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    Outlines_template = require("./components/Outlines.marko"),
    Outlines_tag = marko_loadTag(Outlines_template),
    Attachments_template = require("./components/Attachments.marko"),
    Attachments_tag = marko_loadTag(Attachments_template),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Accessories_template = require("../../../../components/Accessories/index.marko"),
    Accessories_tag = marko_loadTag(Accessories_template),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    DialogModal_template = require("../../../../../components/DialogModal/index.marko"),
    DialogModal_tag = marko_loadTag(DialogModal_template),
    AssignCertBadgeModal_template = require("../../../../components/AssignCertBadgeModal/index.marko"),
    AssignCertBadgeModal_tag = marko_loadTag(AssignCertBadgeModal_template),
    Wrapper_Admin_template = require("../../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "position-relative"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("b643f2"),
    marko_node0 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "mt-4"
      },
    marko_node1 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "font-medium-2"
      },
    marko_attrs3 = {
        "class": "position-absolute top-0 m-75"
      },
    marko_attrs4 = {
        "class": "float-right"
      },
    marko_node3 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "btn btn-light btn-lg mr-25"
      },
    marko_node4 = marko_createElement("br", null, "24", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "25", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "26", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "list-unstyled"
      },
    marko_attrs7 = {
        "class": "py-75 font-medium-1"
      },
    marko_attrs8 = {
        "class": "justify-content-center"
      },
    marko_node7 = marko_createElement("i", {
        "class": "bx bx-minus font-medium-2 text-muted mr-4 float-left"
      }, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs9 = {
        "class": "py-75 font-medium-1"
      },
    marko_attrs10 = {
        "class": "justify-content-center"
      },
    marko_node8 = marko_createElement("i", {
        "class": "bx bx-minus font-medium-2 text-muted mr-4 float-left"
      }, "36", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs11 = {
        "class": "py-75 font-medium-1"
      },
    marko_attrs12 = {
        "class": "justify-content-center"
      },
    marko_node9 = marko_createElement("i", {
        "class": "bx bx-minus font-medium-2 text-muted mr-4 float-left"
      }, "41", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs13 = {
        "class": "py-75 font-medium-1"
      },
    marko_attrs14 = {
        "class": "justify-content-center"
      },
    marko_node10 = marko_createElement("i", {
        "class": "bx bx-minus font-medium-2 text-muted mr-4 float-left"
      }, "47", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs15 = {
        "class": "ml-5 py-50 list-inline"
      },
    marko_attrs16 = {
        "class": "p-25"
      },
    marko_attrs17 = {
        "class": "chip theme-bg-lighten"
      },
    marko_attrs18 = {
        "class": "chip-body font-small-5"
      },
    marko_attrs19 = {
        "class": "chip-text py-50"
      },
    marko_attrs20 = {
        "class": "py-75 font-medium-1"
      },
    marko_node11 = marko_createElement("br", null, "57", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs21 = {
        "class": "btn btn-light btn-lg mr-25"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      title: state.program && state.program.name,
      renderBody: function(out) {
        if (state.program === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (state.program === false) {
          EmptyList_tag({
              message: "The page you are trying to access is nowhere to be found",
              routeTo: "programs"
            }, out, __component, "2");
        } else {
          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                WSAdapt_tag({
                    hs: "col-12",
                    qs: "col-4",
                    class: "row col-md-3 col-12",
                    renderBody: function(out) {
                      WSAdapt_tag({
                          ns: "col-12",
                          qs: "col-12",
                          hs: "col-6",
                          renderBody: function(out) {
                            out.be("div", marko_attrs0, "6", component);

                            Image_tag({
                                alt: state.program.name,
                                src: state.program.poster,
                                class: "img-fluid rounded",
                                style: "width:100%;min-height:12rem"
                              }, out, __component, "7");

                            if (state.program.availability) {
                              out.be("div", marko_attrs3, "8", component);

                              Availability_tag({
                                  type: state.program.availability
                                }, out, __component, "9");

                              out.ee();
                            }

                            out.n(marko_node0, component);

                            out.be("div", marko_attrs1, "11", component);

                            if (state.program.difficultyLevel) {
                              DifficultyLevel_tag({
                                  type: state.program.difficultyLevel
                                }, out, __component, "12");
                            }

                            if (state.program.rating) {
                              out.be("span", marko_attrs4, "13", component);

                              StarRating_tag({
                                  score: 3.5
                                }, out, __component, "14");

                              out.ee();
                            }

                            out.ee();

                            out.ee();

                            out.n(marko_node1, component);

                            out.n(marko_node2, component);

                            out.e("p", marko_attrs2, "17", component, 1)
                              .t(state.program.description, component);

                            if (!state.program.isPublished) {
                              WSAdapt_tag({
                                  ns: "d-none",
                                  qs: "d-none",
                                  renderBody: function(out) {
                                    out.n(marko_node3, component);

                                    out.be("button", marko_attrs5, "20", component, null, 0, {
                                        onclick: __component.d("click", "deleteProgram", false)
                                      });

                                    Locale_tag({
                                        text: "Delete"
                                      }, out, __component, "21");

                                    out.ee();

                                    route_link_tag({
                                        class: "btn btn-primary btn-lg ml-25",
                                        href: "/edit-program/" + state.program.programId,
                                        renderBody: function(out) {
                                          Locale_tag({
                                              text: "Edit"
                                            }, out, __component, "23");
                                        }
                                      }, out, __component, "22");

                                    out.n(marko_node4, component);

                                    out.n(marko_node5, component);

                                    out.n(marko_node6, component);
                                  }
                                }, out, __component, "18");
                            }
                          }
                        }, out, __component, "5");

                      WSAdapt_tag({
                          ns: "col-12",
                          qs: "col-12",
                          hs: "col-6",
                          renderBody: function(out) {
                            out.be("ul", marko_attrs6, "28", component);

                            if (state.program.code) {
                              out.be("li", marko_attrs7, "29", component);

                              out.be("div", marko_attrs8, "30", component);

                              out.n(marko_node7, component);

                              out.be("span", null, "32", component);

                              Locale_tag({
                                  text: "Code"
                                }, out, __component, "33");

                              out.t(": ");

                              out.t(state.program.code, component);

                              out.ee();

                              out.ee();

                              out.ee();
                            }

                            if (state.program.points) {
                              out.be("li", marko_attrs9, "34", component);

                              out.be("div", marko_attrs10, "35", component);

                              out.n(marko_node8, component);

                              out.be("span", null, "37", component);

                              Locale_tag({
                                  text: "Points"
                                }, out, __component, "38");

                              out.t(": ");

                              out.t(state.program.points, component);

                              out.ee();

                              out.ee();

                              out.ee();
                            }

                            if (state.program.price && (state.program.price.amount > 0)) {
                              out.be("li", marko_attrs11, "39", component);

                              out.be("div", marko_attrs12, "40", component);

                              out.n(marko_node9, component);

                              out.be("span", null, "42", component);

                              Locale_tag({
                                  text: "Price"
                                }, out, __component, "43");

                              out.t(": ");

                              Price_tag({
                                  amount: state.program.price.amount,
                                  currency: state.program.price.currency
                                }, out, __component, "44");

                              out.ee();

                              out.ee();

                              out.ee();
                            }

                            if (Array.isArray(state.program.packages) && state.program.packages.length) {
                              out.be("li", marko_attrs13, "45", component);

                              out.be("div", marko_attrs14, "46", component);

                              out.n(marko_node10, component);

                              out.be("span", null, "48", component);

                              Locale_tag({
                                  text: "Packages"
                                }, out, __component, "49");

                              out.t(": ");

                              out.be("ul", marko_attrs15, "50", component);

                              marko_forOf(state.program.packages, function(each, index) {
                                var $keyValue$0 = "@" + index,
                                    $keyScope$0 = "[" + ($keyValue$0 + "]");

                                out.e("li", marko_attrs16, $keyValue$0, component, 1)
                                  .e("div", marko_attrs17, "51" + $keyScope$0, component, 1)
                                    .e("div", marko_attrs18, "52" + $keyScope$0, component, 1)
                                      .e("span", marko_attrs19, "53" + $keyScope$0, component, 1)
                                        .t(each.toCapitalCase(), component);
                              });

                              out.ee();

                              out.ee();

                              out.ee();

                              out.ee();
                            }

                            if (state.program.schedules) {
                              out.be("li", marko_attrs20, "54", component);

                              Schedules_tag({
                                  list: state.program.schedules
                                }, out, __component, "55");

                              out.ee();
                            }

                            out.ee();

                            if (!state.program.isPublished) {
                              WSAdapt_tag({
                                  hs: "d-none",
                                  renderBody: function(out) {
                                    out.n(marko_node11, component);

                                    out.be("button", marko_attrs21, "58", component, null, 0, {
                                        onclick: __component.d("click", "deleteProgram", false)
                                      });

                                    Locale_tag({
                                        text: "Delete"
                                      }, out, __component, "59");

                                    out.ee();

                                    route_link_tag({
                                        class: "btn btn-primary btn-lg ml-25",
                                        href: "/edit-program/" + state.program.programId,
                                        renderBody: function(out) {
                                          Locale_tag({
                                              text: "Edit"
                                            }, out, __component, "61");
                                        }
                                      }, out, __component, "60");
                                  }
                                }, out, __component, "56");
                            }
                          }
                        }, out, __component, "27");
                    }
                  }, out, __component, "4");

                WSAdapt_tag({
                    ns: "pl-2",
                    qs: "pl-2",
                    class: "col",
                    renderBody: function(out) {
                      Outlines_tag({
                          list: state.program.outlines,
                          programId: state.program.programId,
                          editable: !state.program.isPublished
                        }, out, __component, "63", [
                        [
                          "dialog",
                          "onDialog",
                          false
                        ],
                        [
                          "change",
                          "onOutlinesUpdate",
                          false
                        ],
                        [
                          "update-program",
                          "updateProgram",
                          false
                        ]
                      ]);

                      Attachments_tag({
                          list: state.program.attachments,
                          editable: !state.program.isPublished
                        }, out, __component, "64", [
                        [
                          "dialog",
                          "onDialog",
                          false
                        ],
                        [
                          "change",
                          "onAttachmentsUpdate",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "62");

                WSAdapt_tag({
                    ns: "col-3",
                    qs: "col-12",
                    hs: "col-12",
                    class: "position-relative mt-md-0 mt-4 p-0",
                    renderBody: function(out) {
                      Accessories_tag(marko_assign({}, state.program, {
                          editable: !state.program.isPublished
                        }), out, __component, "66", [
                        [
                          "update",
                          "updateProgram",
                          false
                        ],
                        [
                          "open",
                          "onShowModal",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "65");
              }
            }, out, __component, "3");

          if (state.showDialog) {
            const { message, actions, ...rest } = state.showDialog

            DialogModal_tag(marko_assign({
                message: message,
                actions: actions
              }, rest), out, __component, "67", [
              [
                "dismiss",
                "onDialog",
                false,
                [
                    null
                  ]
              ]
            ]);
          }

          if (!(!state.showModal)) {
            AssignCertBadgeModal_tag(state.showModal, out, __component, "68", [
              [
                "dismiss",
                "onShowModal",
                false,
                [
                    false
                  ]
              ]
            ]);
          }
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
